import { render } from "./TutorSettingsPage.vue?vue&type=template&id=3189cb2c"
import script from "./TutorSettingsPage.vue?vue&type=script&lang=js"
export * from "./TutorSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__